import { useCallback, useEffect, useRef } from 'react';
export var useOnOutsideClick = function (componentRef, callback, ignoreClassName, isDisabled) {
    if (ignoreClassName === void 0) { ignoreClassName = 'ignore-outside-click'; }
    if (isDisabled === void 0) { isDisabled = false; }
    var innerClickCapturedRef = useRef(false);
    var handlerRef = useRef(callback);
    var innerClickListener = function () {
        if (!innerClickCapturedRef.current) {
            innerClickCapturedRef.current = true;
        }
    };
    var listener = useCallback(function (event) {
        var target = event.target;
        var classList = target.classList, shadowRoot = target.shadowRoot;
        if (innerClickCapturedRef.current ||
            (classList === null || classList === void 0 ? void 0 : classList.contains(ignoreClassName)) ||
            (target === null || target === void 0 ? void 0 : target.closest(".".concat(ignoreClassName)))) {
            innerClickCapturedRef.current = false;
            return;
        }
        if (componentRef && componentRef.current) {
            if (target.shadowRoot) {
                if (!shadowRoot.contains(componentRef.current)) {
                    handlerRef.current(event);
                }
            }
            else if (!componentRef.current.contains(target)) {
                handlerRef.current(event);
            }
        }
    }, [componentRef, ignoreClassName]);
    useEffect(function () {
        handlerRef.current = callback;
    });
    useEffect(function () {
        var currentHTMLRef = componentRef.current;
        if (!isDisabled) {
            currentHTMLRef === null || currentHTMLRef === void 0 ? void 0 : currentHTMLRef.addEventListener('mousedown', innerClickListener);
            currentHTMLRef === null || currentHTMLRef === void 0 ? void 0 : currentHTMLRef.addEventListener('touchstart', innerClickListener);
            document.addEventListener('click', listener);
            document.addEventListener('touchstart', listener);
        }
        return function () {
            currentHTMLRef === null || currentHTMLRef === void 0 ? void 0 : currentHTMLRef.removeEventListener('onMouseDown', innerClickListener);
            currentHTMLRef === null || currentHTMLRef === void 0 ? void 0 : currentHTMLRef.removeEventListener('onTouchStart', innerClickListener);
            document.removeEventListener('click', listener);
            document.removeEventListener('touchstart', listener);
        };
    });
};
